import React, { useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/conquistas/header/Header";
import Midia from "../../components/conquistas/midia/Midia";
import DetalhesConquista from "../../components/conquistas/detalhesConquista/DetalhesConquista";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import { DashboardLayout, MainContent } from "../dash/styles";
import { Container } from "./styles";

export default function CriarConquistas() {
  const navigate = useNavigate();

  const [conquistaData, setConquistaData] = useState({
    titulo: "",
    descricao: "",
    tags: [],
    xp: 0,
    ativa: true,
    imagem: null,
    preview: "",
    criterioDesbloqueio: {
      tipo: "EVENTO",
      acao: "INSCRICAO",
      quantidade: 1,
    },
  });

  const handleSave = async () => {
    if (!conquistaData.titulo || !conquistaData.descricao) {
      alert("Preencha o título e a descrição.");
      return;
    }

    const formData = new FormData();

    formData.append("titulo", conquistaData.titulo);
    formData.append("descricao", conquistaData.descricao);
    formData.append("xp", String(conquistaData.xp));
    formData.append("ativa", String(conquistaData.ativa));
    formData.append("tags", JSON.stringify(conquistaData.tags));
    formData.append(
      "criterioDesbloqueio",
      JSON.stringify(conquistaData.criterioDesbloqueio)
    );

    if (conquistaData.imagem instanceof File) {
      formData.append("imagem", conquistaData.imagem);
    }

    try {
      await api.post("/api/achievements", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Conquista criada com sucesso!");
      navigate("/conquistas");
    } catch (error) {
      console.error("Erro ao criar conquista:", error);
      alert("Erro ao criar conquista. Verifique o backend.");
    }
  };

  return (
    <DashboardLayout>
      <Sidebar />

      <Container>
        <Header
          title="Criar nova conquista"
          description="Adicione uma nova conquista à plataforma"
          breadcrumbMain="Conquistas"
          breadcrumbCurrent="Criar conquista"
        />

        <MainContent>
          <Midia
            initialPreview={conquistaData.preview}
            onFileSelect={(file, preview) =>
              setConquistaData({ ...conquistaData, imagem: file, preview })
            }
          />

          <DetalhesConquista
            conquistaData={conquistaData}
            setConquistaData={setConquistaData}
          />

          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
